import styled, { css } from 'styled-components';

const BUTTON_VARIANTS = {
  primary: css`
    background-color: ${(props) => props.theme.color.primary};
    color: ${(props) => props.theme.color.primaryForeground};
    border: 1px solid ${(props) => props.theme.color.primary};
    &:hover {
      background-color: ${(props) => props.theme.color.primaryHover};
      color: ${(props) => props.theme.color.primaryForegroundHover};
      border: 1px solid ${(props) => props.theme.color.primary};
    }
    &:focus {
      outline: none;
    }
  `,
  secondary: css`
    background-color: unset;
    color: ${(props) => props.theme.color.primary};
    border: 1px solid ${(props) => props.theme.color.primary};
    &:hover {
      background-color: ${(props) => props.theme.color.primary};
      color: #ffffff;
      border: 1px solid ${(props) => props.theme.color.primary};
    }
    &:focus {
      outline: none;
    }
  `,
  secondaryBright: css`
    background-color: ${(props) => props.theme.color.primaryBrightTransparent};
    color: ${(props) => props.theme.color.primaryBright};
    border: 2px solid ${(props) => props.theme.color.primaryBright};
    &:hover {
      background-color: ${(props) => props.theme.color.primaryBright};
      color: #ffffff;
      border: 2px solid ${(props) => props.theme.color.primaryBright};
    }
    &:focus {
      outline: none;
    }
  `,
  tertiary: css`
    background-color: unset;
    color: ${(props) => props.theme.color.black};
    border: 1px solid ${(props) => props.theme.color.black};
    &:hover {
      background-color: ${(props) => props.theme.color.secondaryHover};
      color: #ffffff;
      border: 1px solid ${(props) => props.theme.color.secondaryForegroundHover};
    }
    &:focus {
      outline: none;
    }
  `,
} as const;

const BUTTON_SIZES = {
  extraSmall: css`
    font-size: 12px;
    padding: 10px 15px;
    max-width: 100px;
  `,
  small: css`
    font-size: 14px;
    padding: 15px 20px;
  `,
  medium: css`
    font-size: 18px;
    padding: 13px 40px;
  `,
  large: css`
    font-size: 24px;
    padding: 16px 60px;
  `,
  default: css``,
} as const;

export type ButtonVariant = keyof typeof BUTTON_VARIANTS;

export type ButtonSize = keyof typeof BUTTON_SIZES;

const ROUND_OVERRIDE_STYLES = css`
  padding: 13px;
  border-radius: 100%;
  height: 18px;
  width: 18px;
`;

export const StyledButtonBase = styled.button<{
  $variant: ButtonVariant;
  $round: boolean;
  $size: ButtonSize;
  $fullWidth: boolean;
  $disableCapslock?: boolean;
  $chevron?: boolean;
}>`
  display: inline-flex;
  padding: ${(props) => (props.$chevron ? '0 !important' : '13px 40px')};
  height: ${(props) => (props.$chevron ? '30px !important' : '')};
  width: ${(props) => (props.$chevron ? '30px !important' : '')};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-transform: ${(props) => (props.$disableCapslock ? 'none' : 'uppercase')};
  font-size: 18px;
  font-weight: 600;
  border-radius: ${(props) => props.theme.radius.md};
  ${(props) => props.$fullWidth && 'width: 100%;'}
  box-sizing: border-box;
  transition:
    background-color 0.2s,
    color 0.2s,
    border 0.2s;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${(props) => BUTTON_VARIANTS[props.$variant]}

  ${(props) => props.$round && ROUND_OVERRIDE_STYLES}

  ${(props) => BUTTON_SIZES[props.$size]}
`;
